import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";

import { SharedModule } from "./../../shared/shared.module";
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { PtImageMappingComponent } from './components/pt-image-mapping.component';
import { SpecimenBasedComponent } from './specimen-based/specimen-based.component';
import { PtImageMappingService } from './../../service/pt-image-mapping.service';
import { CaseBasedComponent } from './case-based/case-based.component';
import { AddImageDailogComponent } from './dailog/specimen/add-image-dailog/add-image-dailog.component';
import { SCopyImageComponent } from './dailog/specimen/s-copy-image/s-copy-image.component';
import { AddImageErrorComponent } from './dailog/specimen/add-image-error/add-image-error.component';
import { RemoveImageComponent } from './dailog/specimen/remove-image/remove-image.component';
import { ImageLogComponent } from './dailog/specimen/image-log/image-log.component';

import { CaseAddImageDailogComponent } from './dailog/case/case-add-image-dailog/case-add-image-dailog.component';
import { CaseCopyImageDailogComponent } from './dailog/case/case-copy-image-dailog/case-copy-image-dailog.component';
import { CaseRemoveImageDailogComponent } from './dailog/case/case-remove-image-dailog/case-remove-image-dailog.component';
import { CaseLogImageComponent } from './dailog/case/case-log-image/case-log-image.component';

@NgModule({
    declarations: [
        PtImageMappingComponent,
        SpecimenBasedComponent,
        CaseBasedComponent,
        AddImageDailogComponent,
        SCopyImageComponent,
        AddImageErrorComponent,
        RemoveImageComponent,
        ImageLogComponent,
        CaseAddImageDailogComponent,
        CaseCopyImageDailogComponent,
        CaseRemoveImageDailogComponent,
        CaseLogImageComponent
    ],
    entryComponents: [
        AddImageDailogComponent,
        SCopyImageComponent,
        AddImageErrorComponent,
        RemoveImageComponent,
        ImageLogComponent,
        CaseAddImageDailogComponent,
        CaseCopyImageDailogComponent,
        CaseRemoveImageDailogComponent,
        CaseLogImageComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        FormsModule,
        SharedModule
    ],
    providers: [
        // PtImageMappingComponent,
        PtImageMappingService
    ]
})

export class PtImageMappingModule { }